import accents from 'remove-accents';

export const translateAccents = (str: any) => {
    if (!str || typeof str !== 'string') {
        return str;
    }
    return accents.remove(str);
};
